import { IMessageCapability } from './message-capability';
export interface IModel {
  deviceType: string;
  manufacturer: string;
  capabilities: string[];
  messageCapabilities?: IMessageCapability[];
  modelUid: string;
  createdDate: Date;
  modifiedDate: Date;
  version: number;
  status: string;
}
